import PortletConstants from '../PortletConstants';
import PortletFactoryRegistry from '../PortletFactoryRegistry';
import GoogleMap from './googleMap';

const factory = (portletId) => new GoogleMap(portletId);
PortletFactoryRegistry.register(PortletConstants.MAP, factory);
